import React, { ReactNode, ComponentType } from 'react';

interface ConditionalWrapProps {
  condition: boolean;
  wrapper: ComponentType<any>;
  wrapperProps?: Record<string, any>;
  children: ReactNode;
}

export function ConditionalWrap({
  condition,
  wrapper,
  wrapperProps,
  children,
}: ConditionalWrapProps) {
  return condition
    ? React.createElement(wrapper, { ...wrapperProps, children })
    : children;
}
